// extracted by mini-css-extract-plugin
export default {"mangoTango":"#e17a00","subscribeLink":"#60bf02","colorGreen":"#6c0","colorWhite":"#fff"};